const Unit = (props) => {
    const {unit} = props;
    return (
        <div className={`bg-gray-200 rounded-sm w-auto text-xs font-bold truncate inline-block px-3 py-1 mt-1`}>
            {unit}
        </div>
    )
}

export default Unit;